import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { AriaLogo } from './AriaLogo';
import { toast } from 'sonner';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { setSession } = useAuth();
  // useRef (not useState): prevents double processing under React StrictMode
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const finish = (path) => {
      // Clear the fragment so the callback never re-triggers
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
      navigate(path, { replace: true });
    };

    if (!sessionId) {
      finish('/login');
      return;
    }

    api
      .post('/auth/google/session', null, { headers: { 'X-Session-ID': sessionId } })
      .then((res) => {
        setSession(res.data.token, res.data.user);
        finish('/');
      })
      .catch((err) => {
        console.error('Google session exchange failed:', err);
        toast.error(t('auth.google_error'));
        finish('/login');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[hsl(210,25%,6%)] flex flex-col items-center justify-center gap-4" data-testid="auth-callback-screen">
      <AriaLogo size={48} />
      <Loader2 size={26} className="text-cyan-400 animate-spin" />
      <p className="text-xs text-muted-foreground">{t('auth.google_connecting')}</p>
    </div>
  );
};

export default AuthCallback;
